"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/tabs/style");
var _tabs = _interopRequireDefault(require("antd/lib/tabs"));
var _react = _interopRequireDefault(require("react"));
var _AntdTab = _interopRequireDefault(require("./AntdTab"));
require("./Tabs.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AntdTabs = function AntdTabs(props) {
  return /*#__PURE__*/_react.default.createElement(_tabs.default, props, props.children);
};
AntdTabs.Tab = _AntdTab.default;
var _default = AntdTabs;
exports.default = _default;